<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">عملاء حاولوا التسجيل</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">عملاء حاولوا التسجيل</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <div class="container-fluid">
        <!--FILTER-->
        <div class="card shadow card-warning card-outline mt-5">
          <div class="card-header">
            <button
              class="filter-btn w-100 text-start collapse-toggle"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#filterCard"
              aria-expanded="false"
              aria-controls="filterCard"
            >
              <i class="fa-solid fa-magnifying-glass"></i> بحث وتصفية
            </button>
          </div>

          <div class="collapse" id="filterCard">
            <form action="" @submit.prevent="filterSubmit">
              <div class="card-body">
                <div class="row">
                  <div class="col-6 col-sm-3 mb-3">
                    <input type="text" v-model="searchName" class="form-control" placeholder="الاسم">
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <input type="text" v-model="searchMobile" class="form-control" placeholder="رقم الجوال">
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <select v-model="searchStatus" class="form-control">
                      <option :value="null">حالة رمز التحقق</option>
                      <option v-for="(val, key) in statusChoices" :value="key" :key="key">{{ val }}</option>
                    </select>
                  </div>
                  <div 
                    class="d-flex align-items-center justify-content-between p-2 mb-2 rounded border"
                    @click="showDateFilter = !showDateFilter"
                    style="cursor:pointer; transition:0.3s;"
                    :class="showDateFilter ? 'bg-light border-primary' : ''"
                  >
                    <div class="d-flex align-items-center gap-2">
                      <i class="bi bi-calendar fs-5 text-primary"></i>
                      <span class="fw-bold">تاريخ آخر محاولة تسجيل</span>
                    </div>
                    <div>
                      <i :class="showDateFilter ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
                    </div>
                  </div>
                  <div v-if="showDateFilter" class="row">
                    <div class="col-6 col-sm-3 mb-3">
                      <label class="form-label">من تاريخ</label>
                      <input type="date" v-model="searchDateFrom" class="form-control">
                    </div>
                    <div class="col-6 col-sm-3 mb-3">
                      <label class="form-label">إلى تاريخ</label>
                      <input type="date" v-model="searchDateTo" class="form-control">
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="row">
                  <div class="col text-end">
                    <button type="submit" class="btn btn-warning btn-sm"><i class="fa-solid fa-filter"></i> بحث وتصفية</button>
                    <button type="button" class="btn btn-light btn-sm ms-3" @click.prevent="clearFilter"><i class="fa-solid fa-filter-circle-xmark"></i> إلغاء</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <!--begin::Row-->
        <div class="row">
          <div class="col">
            <div class="card card-secondary card-outline mb-4 mt-5">
              <div class="card-header d-flex align-items-center">
                <div class="card-title mb-0">عملاء حاولوا التسجيل</div>
                <span v-if="countRows > 0"
                  class="badge rounded-pill bg-primary fs-6 px-3 py-2 ms-auto">
                  عدد النتائج ( {{ countRows }} )</span>
              </div>
              <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
              <div class="card-body">
                <mainLoader v-if="mainLoading" />
                <div v-if="!mainLoading" class="row">
                  <div class="col">
                    <div v-if="!rows.length" class="alert alert-info">لا توجد سجلات</div>
                    <div v-else class="table-responsive">
                      <table class="table table-striped align-middle">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>الاسم</th>
                            <th>رقم الجوال</th>
                            <th>عدد المحاولات</th>
                            <th>مصدر الطلب</th>
                            <th>رمز التحقق</th>
                            <th>سجل لاحقاً</th>
                            <th>آخر محاولة تسجيل</th>
                            <th>العمليات</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, index) in rows" :key="row.id">
                            <td>{{ row.id }}</td>
                            <td>{{ row.name || '—' }}</td>
                            <td>
                              <a v-if="row.mobile" :href="waLink(row.mobile)" target="_blank" rel="noopener" class="text-decoration-none me-2" title="مراسلة عبر الواتساب">
                                <i class="bi bi-whatsapp text-success me-1"></i>
                              </a>
                              <span dir="ltr">{{ row.mobile }}</span>
                            </td>
                            <td><span class="badge bg-info text-dark">{{ row.attemptsCount }}</span></td>
                            <td>
                              <span v-if="row.source === 'admin'" class="badge bg-secondary">لوحة التحكم</span>
                              <span v-else-if="row.source === 'ios'" class="badge bg-primary">iPhone</span>
                              <span v-else-if="row.source === 'android'" class="badge bg-primary">Android</span>
                              <span v-else-if="row.source === 'website'" class="badge bg-info">الموقع الإلكتروني</span>
                              <span v-else-if="row.source" class="badge bg-light text-dark border">{{ row.source }}</span>
                              <span v-else>—</span>
                            </td>
                            <td>
                              <span :class="(row.otpStatus == 'done')? 'badge bg-warning text-dark' : 'badge bg-light text-dark border'">{{ statusChoices[row.otpStatus] }}</span>
                            </td>
                            <td>
                              <span v-if="row.isRegistered" class="badge bg-success">نعم</span>
                              <span v-else class="badge bg-secondary">لا</span>
                            </td>
                            <td>{{ formatDate(row.updatedAt) }}</td>
                            <td>
                              <button v-if="checkAccess('users_attempts_delete')" type="button" class="btn btn-danger btn-sm" @click.prevent="deleteRow(row.id, index)">
                                <i class="bi bi-trash"></i>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="row">
                  <div class="col">
                    <ul class="pagination">
                      <li v-if="currentPage > 1" class="page-item"><a class="page-link" href="#" @click.prevent="prevPage()">السابق</a></li>
                      <li v-for="p in pages" :key="p" class="page-item">
                        <a v-if="p == currentPage" class="page-link active" href="javascript:void(0)">{{ p }}</a>
                        <a v-else class="page-link" href="javascript:void(0)" @click="goToPage(p)">{{ p }}</a>
                      </li>
                      <li v-if="rows.length >= 30" class="page-item"><a class="page-link" href="#" @click.prevent="nextPage()">التالي</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
    </div>
    <!--end::App Content-->
  </main>
</template>

<script>
import { toast, checkAccess, formatDate } from '@/helpers/tools';

export default {
  name: 'RegistrationAttemptsList',
  data(){
    return {
      mainLoading: true,
      hasError: false,
      message: '',
      errorNumber: 0,
      rows: [],
      currentPage: parseInt(this.$route.query.page) || 1,
      pages: [],
      searchName: this.$route.query.name || '',
      searchMobile: this.$route.query.mobile || '',
      searchDateFrom: this.$route.query.dateFrom || null,
      searchDateTo: this.$route.query.dateTo || null,
      searchStatus: this.$route.query.status || null,
      showDateFilter: false,
      countRows: 0,
      statusChoices: {},
    }
  },
  methods: {
    checkAccess,
    formatDate,
    waLink(mobile){
      let num = String(mobile).replace(/[^\d+]/g, '');
      if (num.startsWith('00')) num = '+' + num.slice(2);
      else if (num.startsWith('05')) num = '+966' + num.slice(1);
      else if (num.startsWith('5') && num.length === 9) num = '+966' + num;
      else if (!num.startsWith('+')) num = '+' + num;
      return `https://wa.me/${num}`;
    },
    getList(){
      this.mainLoading = true;
      this.hasError = false;
      let urlQuery = [`page=${this.currentPage}`];
      if(this.searchName.trim() != '')
        urlQuery.push(`name=${this.searchName.trim()}`);
      if(this.searchMobile.trim() != '')
        urlQuery.push(`mobile=${this.searchMobile.trim()}`);
      if(this.searchStatus)
        urlQuery.push(`otpStatus=${this.searchStatus}`);
      if(this.searchDateFrom)
        urlQuery.push(`dateFrom=${this.searchDateFrom}`);
      if(this.searchDateTo)
        urlQuery.push(`dateTo=${this.searchDateTo}`);

      this.$router.replace({ query: {
        page: this.currentPage,
        ...(this.searchName !== null && this.searchName !== '' ? { name: this.searchName } : {}),
        ...(this.searchMobile !== null && this.searchMobile !== '' ? { mobile: this.searchMobile } : {}),
        ...(this.searchStatus !== null ? { status: this.searchStatus } : {}),
        ...(this.searchDateFrom ? { dateFrom: this.searchDateFrom } : {}),
        ...(this.searchDateTo ? { dateTo: this.searchDateTo } : {}),
      }}).catch(() => {});

      this.$http.get(`/api/admin/registrationAttempts/list?${urlQuery.join('&')}`).then(({data}) => {
        this.rows = data.rows;
        this.statusChoices = data.statusChoices;
        this.pages = data.pages ?? [this.currentPage];
        this.countRows = data.countRows ?? 0;
        this.mainLoading = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    async deleteRow(id, index){
      const deletePrompt = await this.$swal.fire({
        title: "هل تريد تأكيد حذف السجل ، لا يمكن استعادته مرة اخرى ؟",
        showCancelButton: true,
        confirmButtonText: "حذف",
        cancelButtonText: "إلغاء",
        confirmButtonColor: '#dc3741',
      });

      if (deletePrompt.isConfirmed) {
        this.$http.delete(`/api/admin/registrationAttempts/delete/${id}`).then(({data}) => {
          let buffer = this.rows;
          buffer.splice(index, 1);
          this.rows = buffer;
          toast('تم الحذف بنجاح', 'success');
        }).catch(err => {
          toast('غير قادر على الحذف');
        });
      }
    },
    nextPage(){
      this.currentPage += 1;
      this.getList();
    },
    prevPage(){
      this.currentPage -= 1;
      this.getList();
    },
    goToPage(num){
      this.currentPage = num;
      this.getList();
    },
    filterSubmit(){
      this.currentPage = 1;
      this.getList();
    },
    clearFilter(){
      this.currentPage = 1;
      this.searchName = '';
      this.searchMobile = '';
      this.searchStatus = null;
      this.searchDateFrom = null;
      this.searchDateTo = null;
      this.$router.replace({ query: {} }).catch(() => {});
      this.getList();
    },
  },
  created(){
    this.getList();
  }
}
</script>